import React from "react";
import Button from '@mui/material/Button';
import { ValidateMaterialInput } from "./../ValidateMaterialInput";
const btnsArray = [
  { buttonOperation: "Display" },
  { buttonOperation: "Change" },
  { buttonOperation: "Create" },
];

export default function OverviewButtons({
  material,
  navigate,
  _getMaterialExists,
  _createErrorMessage,
}) {
  const onClick = (buttonOperation, noValidation, navPath) => {
    let navigationUrl;
    if (buttonOperation === "Create") {
      navigationUrl = `/Material/Create`;
      navigate(navigationUrl);
      return;
    }

    let validationMaterialResult = ValidateMaterialInput(
      material,
      _createErrorMessage
    );

    if (!validationMaterialResult) {
      return;
    }

    _getMaterialExists({ data: { Id: material } }, ({ data: isExist }) => {
      if (!isExist) {
        _createErrorMessage("36");
        return;
      }
      const navigationUrl = `/Material/${material}/${buttonOperation}`;
      navigate(navigationUrl);
    });
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
      }}
      className="customButton"
    >
      {btnsArray.map(({ buttonOperation, noValidation, navPath }, i) => (
        <div style={{ width: "48%", marginBottom: 15 }} key={i}>
          <Button
            className="btn btn-primary w-100"
            onClick={() => onClick(buttonOperation, noValidation, navPath)}
          >
            {buttonOperation}
          </Button>
        </div>
      ))}
    </div>
  );
}
